import UestcTokenApi from '@/api/src/token/api/UestcTokenApi.js'

const uestcTokenApi = new UestcTokenApi()

/**
 * 弹窗组件模块 属于子模块
 */
const state = {
  userInfo: {}
};

let fetchUserInfoPromise = null

const actions = {
  /**
   * 用 cookie 恢复当前登录用户；已有用户或进行中的请求会复用，避免重复打接口
   */
  ensureUserInfo({ state, commit }) {
    if (state.userInfo && state.userInfo.id) {
      return Promise.resolve(state.userInfo)
    }
    if (fetchUserInfoPromise) {
      return fetchUserInfoPromise
    }
    fetchUserInfoPromise = uestcTokenApi.getUserInfo()
      .then((resp) => {
        commit('setUserInfo', resp || {})
        return state.userInfo
      })
      .catch((e) => {
        commit('setUserInfo', {})
        throw e
      })
      .finally(() => {
        fetchUserInfoPromise = null
      })
    return fetchUserInfoPromise
  },
};

// 使用 mutation更新 state
const mutations = {
  setUserInfo: (state, data) => {
    state.userInfo = data || {}
  },
};

// 把数据导出时可以对数据做一些操作 但不会改变原数据
const getters = {
  // currentDialog: (state) => state.dialog + '123',
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true,
};
// namespaced: true  命名空间这一行一定要写，这是vuex寻找子组件的依据；
